import { Button } from "components/Button/Button";
import { Logo } from "components/Logo/Logo";
import { motion } from "framer-motion";
import { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { routes } from "routes";

import { EditorProvider, useEditorContext } from "./editor-provider";
// import { EditorEnvironment } from "./EditorEnvironment/EditorEnvironment";
// import { NavList } from "components/NavList/NavList";
// import { useLangContext } from "components/Lang/Lang";
import { Box, Circle, Cone, Cylinder, Earth, Plus, Square, SquareIcon, Torus } from "lucide-react";
import { useLangContext } from "context/Lang";
import { DropdownMenu } from "components/Dropdown/Dropdown";
import { EditorEnvironment } from "./editor-environment/editor-environment";
import { AppIcon } from "assets/app/app-icon";
import { MesheTypes } from "assets/three/MesheTypes";
import { AsyncProcess } from "services/AsyncProcess";
import { ReplaceWords } from "utils/ReplaceWords";
// import { GeometryTypes } from "components/ThreeItems/Geometry/Geometry";
// import { ItemsCategory } from "./ItemsCategory";
// import { ItemsCards } from "./ItemsCards";
// import { Actions } from "components/Actions/Actions";




type EditorProps = {
    // buildingId?: number;
    mapId?:number;
    editorId?:number;
    canEdit?: boolean;
    onDataLoad?: (e?: any) => void;
    inDialog?:boolean;

}



export const Editor = ({ canEdit = true,inDialog=false,mapId, ...props }: EditorProps): ReactElement => {


    const [canEditServer,setCanEditServer] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const mapEditorId = props?.editorId || searchParams.get("editorId");


    useEffect(()=>{
        canEdit&&AsyncProcess({
            type:"post",
            url:ReplaceWords(routes.api.threeItemEditorCheckEdit,{id:mapEditorId}),
            
            setError:()=>{

            },

            effectProcess:[(res)=>{
                if(res?.success!==false){
                    setCanEditServer(res?.data)
                }
            }]
        })
    },[]);  

    return <EditorProvider editorId={props.editorId}   onDataLoad={props?.onDataLoad}>
        <EditorContent  {...{ canEdit:canEditServer,inDialog }} />
    </EditorProvider>
}



const EditorContent = ({ canEdit,inDialog, ...props }: EditorProps) => {


    const navigate = useNavigate();
    const { gW, LanguagesDrop } = useLangContext();
    const { addMesh } = useEditorContext();


    return (<>


        <div className=" w-full h-full  select-none overflow-hidden " >
            {canEdit && <div className=" relative backdrop-blur-lg     z-[100] top-0 left-0 p-2 gap-4  w-full  flex h-[64px]  border-b px-2  items-center     " >
                <motion.div initial={{ x: -100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.4, type: "spring" }} className=" h-full flex items-center  relative ">
                    <Button
                        variant="ghost"
                        onClick={() => navigate(-1)} className="   ">
                        <AppIcon />
                    </Button>
                </motion.div>
                <div >
                    <DropdownMenu
                        trigger={<div className=" flex     gap-2 items-center justify-center " >
                            <Plus size={15} />
                            {gW("add")}

                        </div>}
                        items={[
                            {
                                label: gW("box"),
                                icon: <Box />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.box, name: `${Date.now()}-${MesheTypes.box}` } })
                            },
                            {
                                label: gW("cylinder"),
                                icon: <Cylinder />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.cylinder, name: `${Date.now()}-${MesheTypes.cylinder}` } })
                            },
                            {
                                label: gW("cone"),
                                icon: <Cone />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.cone, name: `${Date.now()}-${MesheTypes.cone}` } })
                            },
                            {
                                label: gW("sphere"),
                                icon: <Earth />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.sphere, name: `${Date.now()}-${MesheTypes.sphere}` } })
                            },
                            {
                                label: gW("plane"),
                                icon: <SquareIcon />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.plane, name: `${Date.now()}-${MesheTypes.plane}` } })
                            },
                            {
                                label: gW("torus"),
                                icon: <Torus />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.torus, name: `${Date.now()}-${MesheTypes.torus}` } })
                            },
                            {
                                label: gW("torusknot"),
                                // يمكنك إضافة أيقونة مناسبة هنا
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.torusknot, name: `${Date.now()}-${MesheTypes.torusknot}` } })
                            },
                            {
                                label: gW("circle"),
                                icon: <Circle />,
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.circle, name: `${Date.now()}-${MesheTypes.circle}` } })
                            },
                            {
                                label: gW("ring"),
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.ring, name: `${Date.now()}-${MesheTypes.ring}` } })
                            },
                            {
                                label: gW("icosahedron"),
                                onClick: () => addMesh?.({ mesh: { type: MesheTypes.icosahedron, name: `${Date.now()}-${MesheTypes.icosahedron}` } })
                            }
                        ]}
                    />

                </div>
            </div>}
            <EditorEnvironment
                canEdit={canEdit}
                inDialog={inDialog}

            />

        </div>

    </>);

}